import { render, staticRenderFns } from "./strucType.vue?vue&type=template&id=e79fa2cc&scoped=true"
import script from "./strucType.vue?vue&type=script&lang=js"
export * from "./strucType.vue?vue&type=script&lang=js"
import style0 from "./strucType.vue?vue&type=style&index=0&id=e79fa2cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79fa2cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e79fa2cc')) {
      api.createRecord('e79fa2cc', component.options)
    } else {
      api.reload('e79fa2cc', component.options)
    }
    module.hot.accept("./strucType.vue?vue&type=template&id=e79fa2cc&scoped=true", function () {
      api.rerender('e79fa2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/strucType.vue"
export default component.exports